import { j as o } from "../../../_virtual/jsx-runtime.js";
import K from "../../../assets/icons/Close.js";
import { Dialog as Q, DialogContent as U, DialogHeader as V, DialogTitle as W, DialogFooter as X } from "../../ui/dialog.js";
import { useState as h } from "react";
import i from "../../atoms/Button/index.js";
import Y from "../../atoms/BaseCard/index.js";
import { cn as n } from "../../../lib/utils.js";
import g from "../../atoms/Divider/index.js";
import { getTitleSize as Z, getCloseIconSize as j, sizeClasses as _ } from "./styles.js";
import C from "./ConfirmDialogTooltip.js";
import { handleDialogOpenChange as $, handleCloseClick as w, confirmClose as u } from "./utils.js";
import { DropdownMenu as N, DropdownMenuContent as D } from "../../../node_modules/@radix-ui/react-dropdown-menu/dist/index.js";
import { DropdownMenuTrigger as v } from "../../ui/dropdown-menu.js";
const co = ({
  title: a,
  open: b,
  onOpenChange: k,
  children: T,
  className: P,
  titleClassName: y,
  titleSize: s = "md",
  hasHeaderDivider: M,
  hasFooter: O,
  hasFooterDivider: F,
  footerCloseButton: c,
  footerActionButton: l,
  customFooterContent: d,
  handleClose: m,
  footerClassName: H,
  size: I = "md",
  requireCloseConfirmation: p,
  closeConfirmationMessage: t = "",
  tooltipCancelBtnLabel: x,
  tooltipConfirmBtnLabel: f,
  bodyClassName: R
}) => {
  const B = _[I], [E, r] = h(!1), [G, e] = h(!1);
  return (
    //This component follows the ShadCN Dialog component structure.
    /* @__PURE__ */ o.jsx(
      Q,
      {
        open: b,
        onOpenChange: (J) => $(
          r,
          e,
          k,
          J
        ),
        children: /* @__PURE__ */ o.jsx(
          U,
          {
            className: n(
              "dialog-content max-h-[90vh] px-0 py-4 shadow-wrapper overflow-auto",
              B,
              P
            ),
            children: /* @__PURE__ */ o.jsxs(Y, { className: "p-0 bg-transparent !shadow-none", children: [
              /* @__PURE__ */ o.jsxs(V, { className: "flex flex-row items-center justify-between space-y-0 space-x-4 px-6", children: [
                /* @__PURE__ */ o.jsx(
                  W,
                  {
                    title: a,
                    className: n(
                      a && "ml-1 mb-2 font-medium",
                      Z(s),
                      y
                    )
                  }
                ),
                /* @__PURE__ */ o.jsx(
                  "div",
                  {
                    className: n("relative", {
                      "pt-1": s === "md" || s === "lg"
                    }),
                    children: /* @__PURE__ */ o.jsxs(N, { children: [
                      /* @__PURE__ */ o.jsx(v, { asChild: !0, children: /* @__PURE__ */ o.jsx(
                        i,
                        {
                          rightIconProps: {
                            iconComponent: K,
                            width: j(s),
                            height: j(s)
                          },
                          bgColor: "transparent",
                          size: !s || s === "md" ? "sm" : "iconSm",
                          className: n(
                            a ? "!mb-4" : "absolute right-[2%] z-10",
                            {
                              "top-3": !a && (!s || s === "md" || s === "lg"),
                              "top-0": !s || s === "base"
                            }
                          ),
                          onClick: () => w(
                            r,
                            e,
                            m,
                            "header",
                            p
                          )
                        }
                      ) }),
                      E && /* @__PURE__ */ o.jsx(D, { sideOffset: -30, children: /* @__PURE__ */ o.jsx(
                        C,
                        {
                          confirmationMessage: t,
                          cancelBtnProps: {
                            children: x,
                            onClick: () => r(!1)
                          },
                          confirmBtnProps: {
                            children: f,
                            onClick: () => u(
                              r,
                              e,
                              m
                            )
                          }
                        }
                      ) })
                    ] })
                  }
                )
              ] }),
              M && /* @__PURE__ */ o.jsx(g, { className: "m-0" }),
              /* @__PURE__ */ o.jsx("div", { className: n("card-body px-6", R), children: T }),
              F && /* @__PURE__ */ o.jsx(g, { className: "m-0 mt-6" }),
              O && /* @__PURE__ */ o.jsx(
                X,
                {
                  className: n(
                    "px-6 mt-6 flex flex-row items-center justify-end relative",
                    H
                  ),
                  children: d || /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
                    c && /* @__PURE__ */ o.jsx("div", { className: "relative pt-1", children: /* @__PURE__ */ o.jsxs(N, { children: [
                      /* @__PURE__ */ o.jsx(v, { asChild: !0, children: /* @__PURE__ */ o.jsx(
                        i,
                        {
                          bgColor: "light",
                          isRounded: !0,
                          size: "md",
                          className: "min-w-[100px]",
                          ...c,
                          onClick: () => w(
                            r,
                            e,
                            m,
                            "footer",
                            p
                          )
                        }
                      ) }),
                      G && /* @__PURE__ */ o.jsx(D, { sideOffset: -250, children: /* @__PURE__ */ o.jsx(
                        C,
                        {
                          confirmationMessage: t,
                          cancelBtnProps: {
                            children: x,
                            onClick: () => e(!1)
                          },
                          confirmBtnProps: {
                            children: f,
                            onClick: () => u(
                              r,
                              e,
                              m
                            )
                          }
                        }
                      ) })
                    ] }) }),
                    l && /* @__PURE__ */ o.jsx(
                      i,
                      {
                        bgColor: "dark",
                        isRounded: !0,
                        size: "md",
                        className: "min-w-[100px]",
                        ...l
                      }
                    )
                  ] })
                }
              )
            ] })
          }
        )
      }
    )
  );
};
export {
  co as default
};
